import type { TFunction } from 'i18next';

/**
 * 将通知的 title/content 从后端存储的 i18n key（及可选参数）翻译为当前语言。
 * 格式：纯 key 如 "notifications.newQuote"，或带参数 "notifications.quoteSubmitted|管理员|CT-20260313-0001"
 */
export function translateNotificationText(text: string, t: TFunction): string {
  if (!text || typeof text !== 'string') return text;

  if (!text.includes('|')) {
    if (text.startsWith('notifications.')) {
      return t(text);
    }
    return text;
  }

  const parts = text.split('|');
  const key = parts[0].trim();
  const params = parts.slice(1).map((p) => (p ?? '').trim());

  if (!key.startsWith('notifications.')) {
    return text;
  }

  const translatedParams = params.map((param) => {
    if (!param) return param;
    if (
      typeof param === 'string' &&
      (param.includes('submitted') ||
        param.includes('quoting') ||
        param.includes('offer_') ||
        param.includes('payment_') ||
        param.includes('progress') ||
        param.includes('goods_') ||
        param.includes('docs_') ||
        param.includes('pickup') ||
        param.includes('closed') ||
        param.includes('aftersales') ||
        param.includes('cancelled') ||
        param.includes('available'))
    ) {
      const statusKey = `tickets.${param}`;
      const translated = t(statusKey);
      return translated !== statusKey ? translated : param;
    }
    return param;
  });

  const interpolation: Record<string, string> = {};
  translatedParams.forEach((value, index) => {
    interpolation[`param${index + 1}`] = value;
  });
  return t(key, interpolation);
}
